export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border relative overflow-hidden">
      <div className="py-14 px-4 sm:px-6 max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8 relative z-10">
        <img src="/the-keep-lockup.png" alt="The Keep" className="h-7 w-auto" data-testid="footer-logo" />
        <p className="text-muted-foreground text-sm max-w-md" data-testid="footer-privacy-line">
          Your answers stay private. They're used only to shape The Keep. Never sold, never shared.
        </p>
        <a
          href="mailto:ryan@thekeep.club"
          data-testid="footer-contact-email"
          className="font-mono text-xs tracking-[0.2em] text-gold hover:text-bone transition-colors duration-300"
        >
          RYAN@THEKEEP.CLUB
        </a>
      </div>
      <div className="px-4 sm:px-6 max-w-7xl mx-auto pb-14 relative z-10 border-t border-border/50 pt-8 space-y-3">
        <p className="text-muted-foreground text-xs leading-relaxed max-w-2xl" data-testid="footer-support-line">
          If you're in a dark place right now, call or text{" "}
          <a href="tel:988" className="text-bone/85 underline decoration-gold/40 underline-offset-4 hover:text-gold transition-colors duration-300" data-testid="footer-988-link">
            988
          </a>{" "}
          (U.S. Suicide &amp; Crisis Lifeline). You don't have to wait until you've built something.
        </p>
        <p className="text-muted-foreground/70 text-xs" data-testid="footer-peer-line">
          The Keep is a peer community. It isn't therapy or medical care.
        </p>
      </div>
      <div
        aria-hidden="true"
        className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-serif font-light text-[22vw] leading-none text-bone/[0.025] whitespace-nowrap"
      >
        THE KEEP
      </div>
    </footer>
  );
}
